import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface AccordionItem {
  id: string;
  title: string;
  content: React.ReactNode;
}

interface AccordionProps {
  items: AccordionItem[];
  defaultOpen?: string[];
}

export const Accordion: React.FC<AccordionProps> = ({ items, defaultOpen = [] }) => {
  const [openItems, setOpenItems] = useState<Set<string>>(new Set(defaultOpen));

  const toggleItem = (itemId: string) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(itemId)) {
      newOpenItems.delete(itemId);
    } else {
      newOpenItems.add(itemId);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <div className="space-y-4">
      {items.map((item) => {
        const isOpen = openItems.has(item.id);
        return (
          <div key={item.id} className="border border-charcoal-200 overflow-hidden">
            <button
              onClick={() => toggleItem(item.id)}
              className="w-full px-6 py-4 text-left bg-charcoal-50 hover:bg-charcoal-100 transition-colors flex items-center justify-between"
            >
              <h3 className="text-lg font-semibold text-charcoal-900">{item.title}</h3>
              {isOpen ? (
                <ChevronDown className="h-5 w-5 text-charcoal-600" />
              ) : (
                <ChevronRight className="h-5 w-5 text-charcoal-600" />
              )}
            </button>
            {isOpen && (
              <div className="px-6 py-4 bg-[var(--bg-raised)]">
                {item.content}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
